import { getRoot, resolveIdentifier, types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';
import { BlackPointType } from './BlackPointType';
import { BlackPointStatus } from './BlackPointStatus';
import { Pharmacy } from './Pharmacy';

export const BlackPoint = types.compose(
  BaseEntity,
  types
    .model('BlackPoint', {
      blackPointId: types.identifierNumber,
      pharmacyId: types.maybe(types.integer),
      blackPointStatusId: types.integer,
      startDate: types.string,
      endDate: types.string,
      blackPointTypeId: types.integer,
      comment: types.maybe(types.string),
    })
    .views((self) => {
      return {
        get pharmacy() {
          if (self.pharmacyId) {
            return resolveIdentifier(Pharmacy, self, self.pharmacyId);
          } else {
            return null;
          }
        },
        get type() {
          return resolveIdentifier(BlackPointType, getRoot(self), self.blackPointTypeId);
        },
        get status() {
          return resolveIdentifier(BlackPointStatus, getRoot(self), self.blackPointStatusId);
        },
      };
    }),
);
